/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Emission rate details.
 * @export
 * @interface EmissionRate
 */
export interface EmissionRate {
    /**
     * 
     * @type {Date}
     * @memberof EmissionRate
     */
    timestamp: Date;
    /**
     * 
     * @type {number}
     * @memberof EmissionRate
     */
    measurement?: number | null;
}

/**
 * Check if a given object implements the EmissionRate interface.
 */
export function instanceOfEmissionRate(value: object): value is EmissionRate {
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function EmissionRateFromJSON(json: any): EmissionRate {
    return EmissionRateFromJSONTyped(json, false);
}

export function EmissionRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionRate {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': (new Date(json['timestamp'])),
        'measurement': json['measurement'] === undefined ? undefined : json['measurement'] === null ? null : json['measurement'],
    };
}

export function EmissionRateToJSON(json: any): EmissionRate {
    return EmissionRateToJSONTyped(json, false);
}

export function EmissionRateToJSONTyped(value?: EmissionRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timestamp': value['timestamp'].toISOString(),
        'measurement': value['measurement'],
    };
}

